(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/teamplayers/assets/javascripts/models/statteamplayers.js') >= 0) return;  svs.modules.push('/components/statistics/teamplayers/assets/javascripts/models/statteamplayers.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.models = svs.statistics.models || {};

  svs.statistics.models.StatTeamPlayers = Backbone.Model.extend({
    url: function() {
      var url =
        svs.core.jupiter.url() +
        '/sport/1/teams/' +
        this.get('teamId') +
        '/roster';

      if (
        this.get('currentLeagues') &&
        this.get('currentLeagues').get('homeLeague')
      ) {
        url += '?leagueId=' + this.get('currentLeagues').get('homeLeague').id;
      }
      return url;
    },
    defaults: function() {
      if ((((svs.statistics || {}).data || {}).teamModels || {}).roster) {
        return this.parse(svs.statistics.data.teamModels.roster);
      }
    },
    initialize: function() {},
    parse: function(response) {
      return response;
    },

    toJSON: function(options) {
      options = _.extend(
        {
          sortedRoster: true
        },
        options
      );

      if (options.sortedRoster) {
        return _.extend(this.toJSON({ sortedRoster: false }), {
          teamRoster: this.getSortedRoster()
        });
      }
      return Backbone.Model.prototype.toJSON.apply(this, arguments);
    },

    getSortedRoster: function(options) {
      options = _.extend(
        {
          clone: true
        },
        options
      );

      var roster = this.get('teamRoster'),
        sortedRoster,
        data = {},
        index = 0;

      if (!roster) {
        return data;
      }

      if (options.clone) {
        sortedRoster = JSON.parse(JSON.stringify(roster));
      } else {
        sortedRoster = roster;
      }

      sortedRoster.positions = this.getPositionsWithNullPositionsLast(
        sortedRoster.positions
      );

      sortedRoster.positions = this.putGoalkeepersFirst(sortedRoster.positions);

      _.each(sortedRoster.positions, function(position) {
        position.players = _.sortBy(position.players, function(player) {
          if (!player.shirtNumber || player.shirtNumber <= 0) {
            return 1000 + index++;
          }
          return player.shirtNumber;
        });
      });

      return sortedRoster;
    },

    getPositionsWithNullPositionsLast: function(positions) {
      var nullPositions = _.where(positions, { defaultPosition: null });
      positions = _.filter(positions, function(position) {
        return position.defaultPosition;
      });

      nullPositions = _.map(nullPositions, function(position) {
        return _.extend(position, { defaultPosition: 'Övriga' });
      });

      positions.push.apply(positions, nullPositions);

      return positions;
    },

    putGoalkeepersFirst: function(positions) {
      var goalkeepers = _.findWhere(positions, { defaultPosition: 'Målvakt' });
      if (goalkeepers) {
        positions = _.filter(positions, function(position) {
          return position.defaultPosition !== 'Målvakt';
        });
        positions.unshift(goalkeepers);
      }
      return positions;
    }
  });
})(Backbone, _, svs);

 })(window);